import Vue from 'vue'
import { vfmPlugin } from 'vue-final-modal'

Vue.use(vfmPlugin)
const els = document.querySelectorAll("[id^='form-trigger--']")
if (els != null) {
  els.forEach((el) => {
    // eslint-disable-next-line no-unused-vars
    const app = new Vue({
      el: el,
      data: () => ({
        showModal: false,
      }),
      delimiters: ['[[', ']]'],
      watch: {
        showModal: {
          handler: function (val) {
            if (this.showModal) {
              this.$nextTick(() => {
                window.Formie.initForms()
              })
              document.documentElement.classList.add('is-clipped')
            } else {
              document.documentElement.classList.remove('is-clipped')
            }
          }
        }
      }
    })
    app.$mount(el)
  })
}
